import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useState, useEffect } from 'react';
import MuiAutocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
const AutocompleteWithObjOptions = ({ autoFocus = false, className = '', color = 'primary', disabled = false, fullWidth = false, handlesCustomInputs = false, handlesMultipleChoices = false, hasError = false, helperText = undefined, id = undefined, initialValue = undefined, isRequired = false, label, loading = false, loadingText = undefined, matchValueOn, onChange = undefined, onInputChange = undefined, options, placeholder = '', shouldHideLabel = false, size = 'medium', variant = 'outlined', ...args }) => {
    const [selectedValue, setSelectedValue] = useState(handlesMultipleChoices ? [] : null);
    // Automatically group and sort options if any have a 'group' property
    const hasGroups = options.some(opt => opt.group);
    const groupBy = hasGroups
        ? (option) => option.group ?? ''
        : undefined;
    // Sort by group (alphabetically), then by label within each group
    const sortedOptions = hasGroups
        ? [...options].sort((a, b) => {
            const groupCompare = (a.group ?? '').localeCompare(b.group ?? '');
            if (groupCompare !== 0)
                return groupCompare;
            return a.label.localeCompare(b.label);
        })
        : options;
    useEffect(() => {
        const defaultValue = handlesMultipleChoices ?
            [] :
            null;
        const newSelectedValue = initialValue ?? defaultValue;
        setSelectedValue(newSelectedValue);
    }, [initialValue]);
    const handleChange = (event, value) => {
        setSelectedValue(value);
        if (onChange) {
            onChange(event, value);
        }
    };
    return (_jsxs(FormControl, { className: className, color: color, disabled: disabled, error: hasError, fullWidth: fullWidth, required: isRequired, size: size, variant: variant, children: [_jsx(MuiAutocomplete, { autoComplete: true, className: className, disabled: disabled, disableListWrap: true, error: +hasError, freeSolo: handlesCustomInputs, getOptionLabel: (option) => option?.label ?? option, groupBy: groupBy, loading: loading, loadingText: loadingText, id: id, isOptionEqualToValue: (option, value) => matchValueOn?.(option, value) ?? option?.value === value?.value, multiple: handlesMultipleChoices, openOnFocus: true, options: sortedOptions, 
                // @ts-ignore - some Typescript magic needed
                onChange: handleChange, renderInput: params => (_jsx(TextField, { ...params, label: label, variant: variant, placeholder: '', color: color, error: hasError ?? undefined, autoFocus: autoFocus })), size: size, value: selectedValue }), helperText &&
                _jsx(FormHelperText, { children: helperText })] }));
};
export default React.memo(AutocompleteWithObjOptions);
//# sourceMappingURL=index.js.map